'use client';

import { useState } from 'react';
import { Toaster } from 'sonner';
import AppLayout from '@/components/AppLayout';
import ReportingFilters, { type Timeframe, type SportFilter, type BetTypeFilter } from './components/ReportingFilters';
import ReportingKPIs from './components/ReportingKPIs';
import MonthlyPLChart from './components/MonthlyPLChart';
import SportBreakdownChart from './components/SportBreakdownChart';
import SportBreakdownTable from './components/SportBreakdownTable';
import WinRateTrendChart from './components/WinRateTrendChart';
import BetTypeBreakdown from './components/BetTypeBreakdown';
import PicksHistoryTable from './components/PicksHistoryTable';

export default function ReportingPage() {
  const [timeframe, setTimeframe] = useState<Timeframe>('all');
  const [sport, setSport] = useState<SportFilter>('all');
  const [betType, setBetType] = useState<BetTypeFilter>('all');

  return (
    <>
      <Toaster richColors position="bottom-right" />
      <AppLayout>
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-[hsl(var(--foreground))] tracking-tight">
            Performance Reports
          </h1>
          <p className="text-[hsl(var(--foreground-muted))] mt-1.5 text-sm">
            Comprehensive analytics across all sports, bet types, and timeframes
          </p>
        </div>

        <ReportingFilters
          timeframe={timeframe}
          setTimeframe={setTimeframe}
          sport={sport}
          setSport={setSport}
          betType={betType}
          setBetType={setBetType}
        />

        <ReportingKPIs timeframe={timeframe} sport={sport} betType={betType} />

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-2">
          <MonthlyPLChart timeframe={timeframe} sport={sport} betType={betType} />
          <SportBreakdownChart timeframe={timeframe} sport={sport} betType={betType} />
        </div>

        <SportBreakdownTable timeframe={timeframe} sport={sport} betType={betType} />

        <WinRateTrendChart timeframe={timeframe} sport={sport} betType={betType} />
        <BetTypeBreakdown timeframe={timeframe} sport={sport} betType={betType} />
        <PicksHistoryTable sport={sport} betType={betType} />
      </AppLayout>
    </>
  );
}